<template>
  <div :class="$style.root">
    <div v-if="review.star" :class="$style.stars" />
    <div :class="$style.header">
      <AtomsConsumerImage src="/images/common/review-user.svg" />
      <p v-if="review.title">{{ review.title }}</p>
    </div>

    <p v-if="review.size">購入サイズ : {{ review.size }}</p>
    <p v-if="usabilityName">お客様の着用感 : {{ usabilityName }}</p>

    <p :class="$style.body"> {{ review.body }}</p>
    <p :class="$style.profile">{{ reviewerProfile }}</p>
  </div>
</template>

<script lang="ts" setup>
import { FilteredFoot } from "@tential/ec-gql-schema/master/user"
import { ReviewFragment } from "~/types/type.generated"
import { sexSelect, ageSelect, usabilitySelect } from "~/utils/const/review"

const props = defineProps<{
  review: ReviewFragment
}>()

const usabilityName = computed(() => {
  return usabilitySelect.find((el) => el.id === props.review.usability)?.name ?? ""
})

const sex = computed(() => {
  return sexSelect.find((el) => el.id === props.review.sex)?.name ?? ""
})

const age = computed(() => {
  return ageSelect.find((el) => el.id === props.review.age)?.name ?? ""
})

const reviewerProfile = computed(() =>
  [
    props.review.name.trim(),
    sex.value,
    age.value,
    props.review.height ? `身長：${props.review.height}cm` : "",
    props.review.weight ? `体重：${props.review.weight}kg` : "",
    props.review.foot_size
      ? `足のサイズ：${props.review.foot_size}cm`
      : props.review.foot && FilteredFoot[props.review.foot]
      ? `足のサイズ：${FilteredFoot[props.review.foot]}`
      : "",
  ]
    .filter((el) => el)
    .join(" / "),
)

const starPercent = computed(() => `${(props.review.star / 5) * 100}%`)
</script>

<style scoped module lang="scss">
.root {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .header {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    p {
      line-height: 1.5;
    }
  }
  .body {
    white-space: pre-wrap;
  }

  .profile {
    color: $black-50;
  }

  .stars {
    &::before {
      content: "★★★★★";
      letter-spacing: 5px;
      background: linear-gradient(90deg, $primary v-bind(starPercent), $white v-bind(starPercent));
      background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-text-stroke: 1px $primary;
    }
  }
}
</style>
